import { useQuery } from "@tanstack/react-query";

export interface BrandingColors {
  item_text: string | null;
  item_border_no_image: string | null;
  item_card_background: string | null;
  name_price_divider: string | null;
  price: string | null;
  background: string | null;
  navbar_background: string | null;
  navbar_icon: string | null;
  navbar_favicon: string | null;
  navbar_favicon_text: string | null;
  navbar_favicon_background: string | null;
  language_text: string | null;
  language_button: string | null;
  language_button_border: string | null;
  social_media_icon: string | null;
  social_media_background: string | null;
  hover_button: string | null;
  hover_button_text: string | null;
  qr_code_color: string | null;
  bottom_sheet_background: string | null;
  bottom_sheet_menu_text: string | null;
}

export interface BrandingResponse {
  status: string;
  message: string;
  data: BrandingColors;
}

const BRANDING_STORAGE_KEY = "sewar_branding_v1";

const getCachedBranding = (): BrandingResponse | undefined => {
  try {
    const cached = localStorage.getItem(BRANDING_STORAGE_KEY);
    if (cached) {
      const parsed = JSON.parse(cached);
      if (parsed && typeof parsed === "object" && parsed.data) {
        return parsed;
      }
    }
  } catch (e) {
    console.error("Error reading cached branding", e);
  }
  return undefined;
};

export const useGetBranding = (options?: { enabled?: boolean }) => {
  return useQuery<BrandingResponse>({
    queryKey: ["branding"],
    enabled: options?.enabled ?? true,
    queryFn: async () => {
      const response = await fetch("https://back.sewargourmet.com/api/v1/branding", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const resData: BrandingResponse = await response.json();
      if (resData && resData.data) {
        try {
          localStorage.setItem(BRANDING_STORAGE_KEY, JSON.stringify(resData));
        } catch (e) {
          console.error("Error saving branding to localStorage", e);
        }
      }
      return resData;
    },
    initialData: getCachedBranding,
    staleTime: 10 * 60 * 1000,         // Cache for 10 minutes to protect the server from unnecessary load
    refetchOnMount: false,             // Do not spam server on mount
    refetchOnReconnect: false,         // Prompted politely via CustomerUpdateBanner
    refetchOnWindowFocus: false,
  });
};
